import { Component } from "@kluntje/core";
import { toggleClass, getParent } from "@kluntje/js-utils/lib/dom-helpers";
import SSOService, { UserObject } from "Services/SSOService";
import FRAPageNotification from "Components/fra-m-page-notification/fra-m-page-notification";

class FRAPageHeader extends Component {
  SSOService = SSOService.getInstance();
  loggedIn?: boolean;

  constructor() {
    super({
      ui: {
        actions: "[data-action]",
        notificationAction: ".fra-m-page-header__actions-item--notification a",
        menu: ".fra-m-page-header--menu",
        languageSwitch: ".fra-m-page-header--language",
      },
      events: [
        {
          event: "click",
          target: "actions",
          handler: "onActionClick",
        },
        {
          event: "click",
          target: "notificationAction",
          handler: "onNotificationActionClick",
        },
        {
          event: "keydown",
          target: "notificationAction",
          handler: "onNotificationActionClick",
        },
      ],
    });

    this.onAuthChange = this.onAuthChange.bind(this);
  }

  /**
   * Lifecycle-Hook: Initializes Component after render
   * @override
   */
  afterComponentRender(): void {
    this.SSOService.subscribe(this.onAuthChange);
  }

  onAuthChange({ loggedIn }: { loggedIn: boolean; user: UserObject | null }) {
    this.loggedIn = loggedIn;

    toggleClass(this.ui.menu, "fra-state-logged-in", loggedIn);
    toggleClass(this.ui.menu, "fra-state-logged-out", !loggedIn);

    toggleClass(this.ui.languageSwitch, "fra-state-logged-in", loggedIn);
    toggleClass(this.ui.languageSwitch, "fra-state-logged-out", !loggedIn);
  }

  /**
   * Dispatch new 'action clicked' event containing the concrete action.
   *
   * @param {Event} e - click event
   */
  onActionClick(e: Event): void {
    e.preventDefault();
    e.stopImmediatePropagation();

    const parent = getParent(e.target as HTMLElement, "[data-action]") as HTMLElement;
    if (parent?.dataset?.action === "map" && (parent as HTMLAnchorElement)?.href) {
      window.dataLayer?.push({
        event: "gaEvent",
        eventCategory: "Header Map",
        eventAction: (parent as HTMLAnchorElement)?.href,
        eventLabel: "Header Map Button Click",
      });
      // eslint-disable-next-line
      (parent as HTMLAnchorElement).target === "_blank"
        ? window.open((parent as HTMLAnchorElement).href, "_blank")?.focus()
        : (window.location.href = (parent as HTMLAnchorElement).href);
    } else {
      window.dispatchEvent(
        new CustomEvent("fra-page-header-action-clicked", {
          detail: {
            action: parent.dataset.action,
          },
        }),
      );
    }
  }

  onNotificationActionClick(e: Event): void {
    if (e instanceof PointerEvent || (e instanceof KeyboardEvent && e.key === "Enter")) {
      e.preventDefault();
      window.dispatchEvent(new Event(FRAPageNotification.OPEN_EVENT));
    }
  }
}

customElements.define("fra-m-page-header", FRAPageHeader);

export default FRAPageHeader;
